import { render } from "./PantryFoodTipTitle.vue?vue&type=template&id=179be85f&ts=true"
import script from "./PantryFoodTipTitle.vue?vue&type=script&lang=ts"
export * from "./PantryFoodTipTitle.vue?vue&type=script&lang=ts"

import "./PantryFoodTipTitle.vue?vue&type=style&index=0&id=179be85f&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__